import React, { useCallback, useState, useEffect } from 'react'
import styled from 'styled-components'
import { styleTheme } from '../../style/theme'
import { BridalPlanProps, BridalPlansContainerProps, BridalPlansPageProps } from './BridalPlans.types'
import { getPrimaryColor } from '../../style/utils'
import { useConfig } from '../../routes'
import { ScrollButton } from './components/ScrollButton'
import { Plans } from './components/Plans'
import { Fetch } from '../../function/Fetch'

type ConfigType = {
  primaryColor: string
  viewTitle?: string | null
  viewTitlePlan?: string | null
}

export const BridalPlans: React.FC<BridalPlansContainerProps> = (props) => {
  const config = useConfig() as ConfigType
  return <StyledPage {...props} primaryColor={config.primaryColor} viewTitlePlan={config.viewTitlePlan} />
}

export const Page: React.FC<BridalPlansPageProps> = ({ viewTitlePlan, className }) => {
  let bridalPlanPage = {}
  let bridalFairPageKey = ''

  const [plans, setPlans] = useState<BridalPlanProps[]>()

  const el = document.getElementById('customer-public')
  if (el !== null) {
    bridalPlanPage = JSON.parse(el.dataset.config || '{}')
    bridalFairPageKey = bridalPlanPage['bridal_fair_page_key']
  }

  const refresh = useCallback(() => {
    ;(async () => {
      const url = `/customer/api/v1/bridal_fair_pages/${bridalFairPageKey}/bridal_plans`
      const res = await Fetch(url, 'GET', {})
      const json = await res.json()
      setPlans(
        json.bridalPlans.map((plan: any) => ({
          ...(plan as BridalPlanProps),
        })),
      )
    })()
  }, [bridalFairPageKey])

  useEffect(() => {
    refresh()
  }, []) // eslint-disable-line react-app/react-hooks/exhaustive-deps

  return (
    <div className={className} id="targetTop">
      {viewTitlePlan && <h3 className="title">{viewTitlePlan}</h3>}
      <div className="bridal-plans-wrapper">
        {<Plans plans={plans} bridalFairPageKey={bridalFairPageKey} primaryColor={bridalPlanPage['primary_color']} />}
      </div>
      <div className="scroll_button_wrapper">
        <ScrollButton primaryColor={bridalPlanPage['primary_color']} />
      </div>
    </div>
  )
}

const StyledPage = styled(Page)`
  max-width: 784px;
  margin: 0 auto;
  background-color: ${styleTheme.colors.white};
  padding: 0;
  padding-bottom: 72px;

  @media (min-width: 520px) {
    padding: 32px 16px;
  }

  > .title {
    text-align: center;
    color: ${getPrimaryColor};
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 24px;
  }

  > .bridal-plans-wrapper {
    max-width: 720px;
    padding-bottom: 46px;

    @media (max-width: 520px) {
      padding: 0 16px;
    }
  }

  > .scroll_button_wrapper {
    background-color: ${styleTheme.colors.white};
    border-top: 2px solid ${styleTheme.colors.gray.light};
    padding: 8px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    box-sizing: border-box;
  }
`
